import { flexRender } from '@tanstack/react-table';

import { If } from '@hsp/react-component-library';

import { IBaseTableComponentProps } from 'types/components/table/components';

function Footer<TData>({ enabled = false, table }: IBaseTableComponentProps<TData>) {
  return (
    <If condition={enabled}>
      <tfoot>
        {table.getFooterGroups().map((footerGroup) => (
          <tr key={footerGroup.id}>
            {footerGroup.headers.map((header) => (
              <th key={header.id}>
                {header.isPlaceholder ? null : flexRender(header.column.columnDef.footer, header.getContext())}
              </th>
            ))}
          </tr>
        ))}
      </tfoot>
    </If>
  );
}

export default Footer;
